/* Ardor Banner Builder: options, live price, artwork layout, cart and quote. Ardor Printing. */
/* v3-v3 (Oct 19, 2026): copy of ardor-banner-builder-v3-v2.js. Adds the Pole Banner material (18oz double-sided, 2 in pockets top and bottom,
   4 corner grommets, 18/24/30 in wide x 24-96 in tall, Banner + Hardware or Banner Only), the backlit color profile (Double Layer night /
   Single Layer day), fabric limits (2 or 3 in pole pockets, no webbing, 8 ft or 90 in max), and data-abb-* attributes on every option
   button so ?preset= links (assets/ardor-designer-preset.js) can pick material, sides, pole pockets, hardware and color profile. */
/* v3 (Oct 8, 2026): copy of ardor-banner-builder-v2.js with small hooks (marked v3) for ardor-banner-layers.js:
   text, clipart and exact-logo layers drawn on the 2D layout, 3D, proof and print files, and the AI banner hand-off. */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }

  // ---------- materials and pricing (online price = 3x supplier cost; shipping built in) ----------
  var BASE = { ds: null, min: 35, rough: 0.72, sheen: 0, wrap: 0.12, sway: 1, weave: 0, weaveAmt: 0.5, weaveFreq: 36, mesh: false, rip: 0, backShow: 0.1, backCol: '#F2F1EE', fabric: false, canDS: false, canSlits: false, canRope: false, canPole: true, canWeb: true, canCorners: false, hem: true, backlit: false, maxShort: 0, hs: '' };
  var MATS = [
    { id: 'v13', name: '13oz Vinyl', sub: 'Indoor and outdoor, our most popular', rate: 3.27, ds: 6.54, canDS: true, canSlits: true, canRope: true, canCorners: true, hs: '13 oz. Outdoor Banner Material' },
    { id: 'b18', name: '18oz Blockout Vinyl', sub: 'Heavy duty, nothing shows through', rate: 5.46, ds: 6.54, rough: 0.66, sway: 0.75, backShow: 0, backCol: '#F5F5F3', canDS: true, canSlits: true, canRope: true, canCorners: true, hs: '18 oz. Outdoor Banner Material' },
    { id: 'mesh', name: '9oz Mesh', sub: 'Lets wind through, for fences and scaffolding', rate: 3.63, ds: 7.26, rough: 0.8, sway: 0.5, mesh: true, rip: 0.3, backShow: 0.62, backCol: '#E9E8E4', canDS: true, canRope: true, canCorners: true, hs: 'Mesh Banner Material' },
    { id: 'fab9', name: '9oz Fabric', sub: 'Wrinkle-free soft drape, for events', rate: 5.94, rough: 0.92, sheen: 0.6, wrap: 0.45, sway: 1.45, weave: 1, weaveAmt: 0.8, weaveFreq: 54, backShow: 0.55, backCol: '#F4F3F0', fabric: true, rip: 1, hs: '9 oz. Fabric Banner (Dye-Sub)', canWeb: false, poleSizes: [2, 3], maxShort: 8, maxShortLabel: '8 ft' },
    { id: 'fabB', name: 'Blockout Fabric', sub: 'Opaque fabric, nothing shows through', rate: 14.85, rough: 0.88, sheen: 0.45, wrap: 0.35, sway: 1.15, weave: 1, weaveAmt: 0.7, weaveFreq: 54, backShow: 0, backCol: '#F1F0ED', fabric: true, rip: 0.8, canWeb: false, poleSizes: [2, 3], maxShort: 8, maxShortLabel: '8 ft' },
    { id: 'tens', name: 'Tension Fabric', sub: 'Stretch fabric for frames and displays', rate: 11.55, rough: 0.76, sheen: 0.5, wrap: 0.3, sway: 0.06, weave: 1, weaveAmt: 0.4, weaveFreq: 72, backShow: 0.4, fabric: true, canWeb: false, poleSizes: [2, 3], maxShort: 7.5, maxShortLabel: '90 in (7 ft 6 in)' },
    { id: 'smooth', name: 'Indoor Smooth', sub: 'Bright satin finish, up to 4 ft 4 in tall', rate: 5.46, rough: 0.42, sway: 0.2, backShow: 0, backCol: '#F7F7F5', hem: false, canPole: false, canWeb: false, weaveAmt: 0.12, maxShort: 4.334, maxShortLabel: '4 ft 4 in' },
    { id: 'backlit', name: 'Backlit Vinyl', sub: 'Glows when lit from behind, for lightboxes', rate: 14.85, min: 150, rough: 0.5, sway: 0.3, backShow: 0.38, backCol: '#EDEDEA', canPole: false, backlit: true, rateNight: 17.33 },
    { id: 'pole', name: 'Pole Banner', sub: '18oz double-sided for street light poles, bracket kit optional', rate: 6.54, ds: 6.54, min: 53.28, rough: 0.66, sway: 0.75, backShow: 0, backCol: '#F5F5F3', canDS: true, forceDS: true, canSlits: true, slitsFree: true, canWeb: false, hem: false, poleBanner: true, poleSizes: [2], hs: 'Pole Banner Set' }
  ].map(function (m) { return Object.assign({}, BASE, m); });
  var DESIGN_FEE = 50;
  var POLE_KIT = { 18: 115.50, 24: 132.00, 30: 138.60 }; // v3-v3: bracket kit, 3x supplier cost (18 in $38.50, 24 in $44.00, 30 in $46.20)
  var POLE_BANNER_SIZES = [[1.5, 2], [1.5, 3], [2, 3], [2, 4], [2.5, 4], [2.5, 6]];
  var HWS = [['kit', 'Banner + Hardware', 'Fiberglass street pole bracket kit included'], ['none', 'Banner Only', 'Just the banner, no brackets']];
  var PROFS = [['night', 'Double Layer print', 'Night-time use, made for a lit lightbox'], ['day', 'Single Layer print', 'Day-time use, brighter without a light']];
  function poleKit(c) { var w = Math.round(c.W * 12); return POLE_KIT[w] || POLE_KIT[30]; }
  var MAX_FILE = 25 * 1024 * 1024;

  var S = { w: '6', h: '3', mat: 'v13', sides: 1, hw: 'kit', prof: 'night', grommet: 'all', pole: 'none', poleSize: 3, slits: false, webbing: 'none', rope: 'none', corners: false, qty: 1, wind: true, lights: true, back: false, design: false, delivery: '', backMode: 'same', face: 'front', artVer: 0 };
  var ART = { front: null, back: null };
  var view = { yaw: 0, pitch: 0.06, zoom: 1, flip: 0, flipTarget: 0, drag: false, lx: 0, ly: 0, lastInput: -100 };
  var eng = null;
  var priceTable = null;

  function matById(id) { for (var i = 0; i < MATS.length; i++) if (MATS[i].id === id) return MATS[i]; return MATS[0]; }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }

  function cfg(over) {
    var s = Object.assign({}, S, over || {});
    var mat = matById(s.mat);
    var W = Math.min(100, Math.max(1, num(s.w, 6)));
    var H = Math.min(100, Math.max(1, num(s.h, 3)));
    var sides = mat.forceDS ? 2 : (mat.canDS ? s.sides : 1);
    var pole = mat.poleBanner ? 'tb' : (mat.canPole ? s.pole : 'none');
    var grommet = mat.poleBanner ? 'corners' : (pole !== 'none' ? 'none' : s.grommet);
    var rope = (mat.canRope && pole === 'none' && !(mat.id === 'mesh' && sides === 2)) ? s.rope : 'none';
    var webbing = mat.canWeb ? s.webbing : 'none';
    var corners = mat.canCorners ? s.corners : false;
    var slits = mat.canSlits ? s.slits : false;
    var hem = mat.hem;
    if (hem && sides === 2 && (mat.id === 'v13' || mat.id === 'b18')) hem = webbing !== 'none';
    return { W: W, H: H, mat: mat, sides: sides, pole: pole, poleSize: (mat.poleSizes && mat.poleSizes.indexOf(s.poleSize) < 0) ? mat.poleSizes[mat.poleSizes.length - 1] : s.poleSize, hw: mat.poleBanner ? (s.hw === 'none' ? 'none' : 'kit') : 'none', prof: mat.backlit ? (s.prof === 'day' ? 'day' : 'night') : '', grommet: grommet, rope: rope, webbing: webbing, corners: corners, slits: slits, hem: hem, qty: Math.max(1, Math.min(500, Math.round(num(s.qty, 1)))), wind: s.wind, lights: s.lights, artVer: s.artVer };
  }

  function boxType(c) {
    if (c.mat.fabric) return 'standard';
    var sh = Math.min(c.W, c.H) * 12;
    if (sh <= 48) return 'standard';
    if (sh >= 89) return 'folded';
    return 'oversize';
  }

  function price(c) {
    var m = c.mat;
    var rate = c.sides === 2 && m.ds ? m.ds : (m.backlit && c.prof === 'night' && m.rateNight ? m.rateNight : m.rate);
    var area = c.W * c.H;
    var print = area * rate;
    var fin = 0;
    if (c.pole !== 'none') fin += print * 0.11;
    if (c.slits && !m.slitsFree) fin += print * 0.055;
    if (c.webbing !== 'none') fin += 4.95 * (c.W + c.H);
    if (c.corners) fin += 132;
    if (c.rope === 'r3') fin += 8.25 * (c.W + c.H);
    if (c.rope === 'r5') fin += 16.5 * (c.W + c.H);
    var each = Math.max(m.min, print + fin) + (m.poleBanner && c.hw === 'kit' ? poleKit(c) : 0);
    var disc = c.qty >= 10 ? 0.10 : (c.qty >= 3 ? 0.05 : 0);
    var ship = (boxType(c) === 'oversize' ? 47.56 : 24.56) + (c.qty - 1);
    var total = each * c.qty * (1 - disc) + ship + (S.design ? DESIGN_FEE : 0);
    var unit = Math.ceil(total / c.qty - 1e-9);
    return { unit: unit, charged: unit * c.qty, disc: disc, area: area };
  }

  function problems(c) {
    var short = Math.min(c.W, c.H), long = Math.max(c.W, c.H);
    if (num(S.w, 0) < 1 || num(S.h, 0) < 1) return 'Banners start at 1 ft on each side.';
    if (c.mat.poleBanner) { var pbw = Math.round(c.W * 1200) / 100, pbh = Math.round(c.H * 1200) / 100; if (!(pbw === 18 || pbw === 24 || pbw === 30) || pbh < 24 || pbh > 96 || Math.abs(pbh - Math.round(pbh)) > 0.01) return 'Pole banners come 18, 24 or 30 in wide (1.5, 2 or 2.5 ft) and 24 to 96 in tall (2 to 8 ft). Pick one of the pole banner sizes.'; }
    if (c.mat.maxShort && short > c.mat.maxShort) return c.mat.name + ' tops out at ' + (c.mat.maxShortLabel || '4 ft 4 in') + ' on the short side. Pick a smaller size or another material.';
    if (short > 10 || long > 100 || num(S.w, 0) > 100 || num(S.h, 0) > 100) return 'One-piece banners go up to 10 ft on the short side and 100 ft long. Request a quote for bigger banners.';
    return '';
  }

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }
  function ftIn(ft) { var inch = Math.round(ft * 12 * 10) / 10; return fmt(inch); }

  // ---------- labels ----------
  var GROMMETS = [['all', 'Every 2 ft, all sides'], ['tb', 'Every 2 ft, top and bottom'], ['lr', 'Every 2 ft, left and right'], ['corners', '4 corners only'], ['none', 'None']];
  var POLES = [['none', 'None'], ['top', 'Top'], ['tb', 'Top and bottom']];
  var POLE_SIZES = [[2, '2 in pocket (1 in pole)'], [3, '3 in pocket (1.5 in pole)'], [4, '4 in pocket (2 in pole)']];
  var WEBBINGS = [['none', 'None'], ['w', 'Webbing'], ['wd', 'Webbing and D-rings']];
  var ROPES = [['none', 'None'], ['r3', '3/16 in rope, top and bottom'], ['r5', '5/16 in rope, top and bottom']];
  var SIZES = [[4, 2], [6, 3], [8, 4], [10, 3], [10, 5], [12, 4], [3, 6]];
  function labelOf(list, k) { for (var i = 0; i < list.length; i++) if (list[i][0] === k) return list[i][1]; return ''; }

  function hemLabel(c) {
    if (c.mat.poleBanner) return 'no hem on the sides, 2 in pole pockets top and bottom.';
    if (!c.mat.hem) return 'Indoor Smooth is cut clean, with no hem.';
    if (!c.hem) return 'none on double-sided vinyl unless you add webbing.';
    if (c.pole === 'top') return 'hemmed sides and bottom, pole pocket on top.';
    if (c.pole === 'tb') return 'hemmed sides, pole pockets top and bottom.';
    return 'hemmed on all sides, included.';
  }

  // ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.disabled) b.disabled = true;
    if (opts.data) Object.keys(opts.data).forEach(function (k) { b.setAttribute('data-' + k, opts.data[k]); });
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function set(patch) { Object.assign(S, patch); render(); }

  // ---------- artwork ----------
  function artFor(face) {
    if (face === 'back' || face === 'back-flat') {
      var c = cfg();
      if (c.sides === 2 && S.backMode === 'different') return ART.back;
      return ART.front;
    }
    return ART.front;
  }
  // v3: text, clipart and logo layers added in the builder (ardor-banner-layers.js). Same face rule as artFor.
  function layerFace(face) { return (face === 'back' || face === 'back-flat') && cfg().sides === 2 && S.backMode === 'different' ? 'back' : 'front'; }
  function hasLayers(f) { return !!(window.ArdorBannerLayers && window.ArdorBannerLayers.has(f)); }
  var LAYER_NOTE = 'Print file made from a flattened image of the artwork plus text and clipart added in the builder.';
  function layerPrintFaces(job, arts, Wi, Hi, notes) {
    return Promise.all(arts.map(function (a, i) {
      var f = i ? 'back' : 'front';
      if (!hasLayers(f)) return null;
      return window.ArdorBannerLayers.composite(f, Wi, Hi, a).then(function (r) {
        job.faces[i] = { art: { file: r.file, name: r.file.name, kind: 'image' }, bg: (a && a.bg) || '#FFFFFF', geomFor: function () { return { x: 0, y: 0, w: Wi, h: Hi }; } };
        if (notes.indexOf(LAYER_NOTE) < 0) notes.push(LAYER_NOTE);
      });
    }));
  }
  function layerSummary(c) {
    var LY = window.ArdorBannerLayers; if (!LY || !LY.list) return '';
    var keys = c.sides === 2 && S.backMode === 'different' ? ['front', 'back'] : ['front'];
    return keys.map(function (k) {
      var items = (LY.list(k) || []).map(function (o) { return o.kind === 'text' ? '"' + String(o.text || '').replace(/\s+/g, ' ').trim() + '"' + (o.font ? ' (' + o.font + ')' : '') : (o.label || o.kind); });
      return items.length ? (keys.length > 1 ? (k === 'front' ? 'Front: ' : 'Back: ') : '') + items.join(', ') : '';
    }).filter(Boolean).join('; ');
  }

  function geom(a, Wi, Hi) {
    var ia = a.natW / a.natH;
    var fillW = Math.max(Wi, Hi * ia);
    var fitW = Math.min(Wi, Hi * ia);
    if (a.mode === 'fill') { a.rw = fillW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    else if (a.mode === 'fit') { a.rw = fitW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    var w = a.rw * Wi, h = w / ia;
    return { x: a.rcx * Wi - w / 2, y: a.rcy * Hi - h / 2, w: w, h: h, fillW: fillW, fitW: fitW };
  }

  function paintFace(ctx, Wi, Hi, face) {
    var a = artFor(face), lf = layerFace(face);
    if (!a) { // v3: no artwork, but text or clipart: white banner with the layers
      if (!hasLayers(lf)) return false;
      ctx.save(); ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); ctx.restore();
      window.ArdorBannerLayers.paint(ctx, Wi, Hi, lf);
      return true;
    }
    ctx.save();
    ctx.fillStyle = a.bg || '#FFFFFF';
    ctx.fillRect(0, 0, Wi, Hi);
    if (a.img) {
      var g = geomForArt(a, a.natW, a.natH, Wi, Hi);
      ctx.drawImage(a.img, g.x, g.y, g.w, g.h);
    } else {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#3D3A36'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var fs = Math.max(2, Math.min(Hi * 0.12, Wi * 0.06));
      ctx.font = '700 ' + fs + 'px Arial, sans-serif';
      ctx.fillText(a.loading ? 'LOADING YOUR FILE' : 'YOUR FILE', Wi / 2, Hi * 0.42);
      ctx.font = '400 ' + (fs * 0.5) + 'px Arial, sans-serif';
      var nm = a.name.length > 46 ? a.name.slice(0, 43) + '...' : a.name;
      ctx.fillText(nm, Wi / 2, Hi * 0.56);
      if (!a.loading) ctx.fillText('Preview not available', Wi / 2, Hi * 0.66);
    }
    ctx.restore();
    if (hasLayers(lf)) window.ArdorBannerLayers.paint(ctx, Wi, Hi, lf); // v3
    return true;
  }

  // v3-v2 (Oct 12, 2026): a finished Ardor template (page = the banner plus its bleed, made by assets/ardor-banner-tpl.js)
  // goes edge to edge on the template, so the bleed falls outside the banner and is trimmed off. Only files the customer
  // picks or drops (fromUser); AI designs and everything else load exactly as before.
  function tplFit(a) {
    var T = window.ArdorBannerTemplate;
    if (!a || !a.fromUser || !a.img || !T || typeof T.match !== 'function') return false;
    var c = cfg(), m = null;
    try { m = T.match(c, a); } catch (e) { m = null; }
    if (!m) return false;
    a.mode = 'custom'; a.rw = m.w / (c.W * 12); a.rcx = 0.5; a.rcy = 0.5;
    a.tpl = { key: m.key, rw: a.rw, bleed: m.bleed };
    toast('Template file detected - placed edge to edge');
    return true;
  }
  function loadFile(file, face, fromUser) {
    var err = $('[data-abb-error]');
    if (!file) return;
    if (file.size > MAX_FILE) { toast(file.name + ' is over 25 MB. Order with a smaller file, then email the full file to info@ardorprinting.com.'); return; }
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    var a = { file: file, name: file.name, kind: isImg ? 'image' : 'file', img: null, natW: 1, natH: 1, mode: isImg ? 'fill' : 'fit', rw: 1, rcx: 0.5, rcy: 0.5, bg: '#FFFFFF' }; a.fromUser = fromUser === true;
    if (!isImg) { previewFile(a, face); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      a.img = img; a.natW = img.naturalWidth || img.width || 1000; a.natH = img.naturalHeight || img.height || 500; tplFit(a);
      ART[face] = a; S.artVer++; render();
    };
    img.onerror = function () { a.kind = 'file'; a.mode = 'fit'; previewFile(a, face); };
    img.src = url;
    if (err) err.hidden = true;
  }

  // PDF, AI, EPS, TIFF and PSD files: draw a preview so customers see their art in 3D and on the proof
  var artViewP = null;
  function loadArtView() {
    if (window.ArdorBannerArtView) return Promise.resolve(window.ArdorBannerArtView);
    if (!artViewP) artViewP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.artviewUrl; sc.async = true;
      sc.onload = function () { window.ArdorBannerArtView ? res(window.ArdorBannerArtView) : rej(new Error('art view')); };
      sc.onerror = function () { artViewP = null; rej(new Error('art view')); };
      document.head.appendChild(sc);
    });
    return artViewP.then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
  }
  function previewFile(a, face) {
    a.loading = true; a.noPreview = false;
    ART[face] = a; S.artVer++; render();
    a.ready = loadArtView().then(function (av) { return av.preview(a.file, { maxPx: 2400 }); }).then(function (r) {
      if (r && r.ok) { a.img = r.canvas; a.natW = r.natW || r.canvas.width; a.natH = r.natH || r.canvas.height; a.src = r.kind; a.vectorPdf = r.vectorPdf || null; tplFit(a); }
      else { a.noPreview = true; a.reason = (r && r.reason) || 'type'; }
    }).catch(function () { a.noPreview = true; a.reason = 'error'; }).then(function () {
      a.loading = false;
      if (ART.front === a || ART.back === a) { S.artVer++; render(); }
    });
  }
  function noPreviewText(a) {
    var tail = ' You can still order with this file, and we\'ll email you a proof to approve before we print.';
    if (a.reason === 'ai-no-pdf') return 'This AI file was saved without PDF content, so we can\'t show it here. In Illustrator, use File > Save As, check "Create PDF Compatible File" and upload it again, or upload a PDF, PNG or JPG.' + tail;
    if (a.reason === 'eps') return 'We can\'t show this EPS file here, usually because it has live text or effects. To see it on your banner, upload it as a PDF or AI file, or outline the text and save the EPS again.' + tail;
    if (a.reason === 'locked') return 'This PDF is password protected, so we can\'t show it here. Upload a copy without a password to see it on your banner.' + tail;
    if (a.reason === 'blank') return 'This file looks empty, so there\'s nothing to show. Check that you picked the right file.' + tail;
    return 'We can\'t show this file here. Upload a PDF, AI, EPS, PNG or JPG to see it on your banner.' + tail;
  }
  function needsEmailProof() {
    if (S.design) return true;
    var c = cfg(), used = [ART.front]; if (c.sides === 2 && S.backMode === 'different') used.push(ART.back);
    return used.some(function (x) { return x && x.noPreview; });
  }

  // ---------- holes and bands (for the flat layout and proof) ----------
  function bands(c) {
    var P = c.poleSize + 0.5;
    return { top: c.pole !== 'none' ? P : (c.hem ? 1 : 0), bottom: c.pole === 'tb' ? P : (c.hem ? 1 : 0), side: c.hem ? 1 : 0 };
  }
  function holes(c, Wi, Hi) {
    var ins = 0.75, out = [], seen = {};
    var add = function (x, y) { var k = Math.round(x * 10) + ':' + Math.round(y * 10); if (seen[k]) return; seen[k] = 1; out.push([x, y]); };
    var run = function (len) { var n = Math.max(1, Math.ceil((len - 2 * ins) / 24)); var a = []; for (var i = 0; i <= n; i++) a.push(ins + i * (len - 2 * ins) / n); return a; };
    var g = c.grommet;
    if (g === 'all' || g === 'tb') run(Wi).forEach(function (x) { add(x, ins); add(x, Hi - ins); });
    if (g === 'all' || g === 'lr') run(Hi).forEach(function (y) { add(ins, y); add(Wi - ins, y); });
    if (g === 'corners') { add(ins, ins); add(Wi - ins, ins); add(ins, Hi - ins); add(Wi - ins, Hi - ins); }
    return out;
  }

  function drawFlat(ctx, c, Wi, Hi, face, guides) {
    if (!paintFace(ctx, Wi, Hi, face)) {
      ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.max(2, Math.min(Hi * 0.1, Wi * 0.05)) + 'px Arial, sans-serif';
      ctx.fillText(S.design ? 'We design it for you' : 'Your artwork goes here', Wi / 2, Hi / 2);
    }
    if (!guides) return;
    var b = bands(c), lw = Math.max(Wi, Hi) / 600;
    ctx.save();
    ctx.fillStyle = 'rgba(12,13,13,0.10)';
    if (b.top) ctx.fillRect(0, 0, Wi, b.top);
    if (b.bottom) ctx.fillRect(0, Hi - b.bottom, Wi, b.bottom);
    if (b.side) { ctx.fillRect(0, 0, b.side, Hi); ctx.fillRect(Wi - b.side, 0, b.side, Hi); }
    var inset = function (d) { return Math.max(d, 1) + 1; };
    ctx.setLineDash([lw * 6, lw * 4]); ctx.lineWidth = lw * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.9)';
    ctx.strokeRect(inset(b.side), inset(b.top), Wi - inset(b.side) * 2, Hi - inset(b.top) - inset(b.bottom));
    ctx.setLineDash([]);
    holes(c, Wi, Hi).forEach(function (p) {
      ctx.beginPath(); ctx.arc(p[0], p[1], 0.55, 0, Math.PI * 2); ctx.fillStyle = '#B9BCBF'; ctx.fill();
      ctx.beginPath(); ctx.arc(p[0], p[1], 0.24, 0, Math.PI * 2); ctx.fillStyle = '#FFFFFF'; ctx.fill();
    });
    ctx.restore();
  }

  // ---------- flat layout editor ----------
  var lay = { canvas: null, scale: 1, drag: false, lx: 0, ly: 0 };
  function drawLayout() {
    var cv = lay.canvas; if (!cv) return;
    var c = cfg();
    var Wi = c.W * 12, Hi = c.H * 12;
    var frame = cv.parentNode;
    var cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app'), padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0); var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20), maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 260;
    var cssW = maxW, cssH = cssW * Hi / Wi;
    if (cssH > maxH) { cssH = maxH; cssW = cssH * Wi / Hi; }
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.style.width = Math.round(cssW) + 'px'; cv.style.height = Math.round(cssH) + 'px';
    cv.width = Math.round(cssW * dpr); cv.height = Math.round(cssH * dpr);
    lay.scale = cssW / Wi;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cv.width / Wi, 0, 0, cv.height / Hi, 0, 0);
    drawFlat(ctx, c, Wi, Hi, S.face === 'back' ? 'back-flat' : 'front', true);
  }

  function editingArt() { return S.face === 'back' ? (S.backMode === 'different' ? ART.back : null) : ART.front; }

  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas;
    cv.addEventListener('pointerdown', function (e) {
      var a = editingArt(); if (!a || !a.img) return;
      lay.drag = true; lay.lx = e.clientX; lay.ly = e.clientY;
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (!lay.drag) return;
      var a = editingArt(); if (!a) return;
      var c = cfg();
      var dx = (e.clientX - lay.lx) / lay.scale, dy = (e.clientY - lay.ly) / lay.scale;
      lay.lx = e.clientX; lay.ly = e.clientY;
      a.mode = 'custom';
      a.rcx += dx / (c.W * 12); a.rcy += dy / (c.H * 12);
      a.rcx = Math.max(-0.5, Math.min(1.5, a.rcx)); a.rcy = Math.max(-0.5, Math.min(1.5, a.rcy));
      S.artVer++; renderArtOnly();
    });
    var end = function () { lay.drag = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    var sc = $('[data-abb-scale]');
    sc.addEventListener('input', function () {
      var a = editingArt(); if (!a || !a.img) return;
      var c = cfg(); var g = geom(a, c.W * 12, c.H * 12);
      a.mode = 'custom'; a.rw = (parseFloat(sc.value) / 100) * g.fillW / (c.W * 12);
      S.artVer++; renderArtOnly();
    });
    $('[data-abb-fill]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fill'; S.artVer++; render(); } });
    $('[data-abb-fit]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fit'; S.artVer++; render(); } });
    $('[data-abb-center]').addEventListener('click', function () { var a = editingArt(); if (a) { if (a.mode !== 'custom') { var c = cfg(); geom(a, c.W * 12, c.H * 12); a.mode = 'custom'; } a.rcx = 0.5; a.rcy = 0.5; S.artVer++; render(); } });
    $('[data-abb-bg]').addEventListener('input', function (e) { var a = editingArt(); if (a) { a.bg = e.target.value; S.artVer++; renderArtOnly(); } });
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { drawLayout(); }).observe(cv.parentNode); } catch (er) {} }
  }

  function renderArtOnly() {
    drawLayout();
    updateArtUi();
    if (eng) eng.sync(cfg());
  }

  function updateArtUi() {
    var c = cfg();
    var a = editingArt();
    var showBackChoice = c.sides === 2;
    $('[data-abb-art-tabs]').hidden = !showBackChoice;
    $('[data-abb-back-choice]').hidden = !(showBackChoice && S.face === 'back');
    if (!showBackChoice && S.face === 'back') S.face = 'front';
    $$('[data-abb-face]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-face') === S.face ? 'true' : 'false'); });
    var drop = $('[data-abb-drop]');
    drop.hidden = S.face === 'back' && S.backMode !== 'different';
    var nameEl = $('[data-abb-file-name]');
    nameEl.hidden = !a; nameEl.textContent = a ? ('Selected: ' + a.name) : '';
    var ctl = $('[data-abb-layout-controls]');
    ctl.hidden = !(a && a.img);
    var empty = $('[data-abb-layout-empty]');
    var rw = $('[data-abb-res-warn]');
    rw.hidden = true;
    if (S.face === 'back' && S.backMode !== 'different') { empty.hidden = false; empty.textContent = 'The back shows the same art as the front.'; }
    else if (a && a.loading) { empty.hidden = false; empty.textContent = 'Loading a preview of your file\u2026'; }
    else if (a && a.noPreview) { empty.hidden = true; rw.hidden = false; rw.textContent = noPreviewText(a); }
    else if (a && a.kind !== 'image') { empty.hidden = false; empty.textContent = 'This is a preview of your file. We print from your original, so the banner will look sharper than the preview.'; }
    else if (!a) { empty.hidden = false; empty.textContent = S.design ? 'We\'ll design your banner and email you a proof.' : 'No artwork yet, so the 3D view shows a sample. Upload yours above, or let us design it.'; }
    else empty.hidden = true;
    if (lay.canvas) lay.canvas.style.touchAction = (a && a.img) ? 'none' : 'auto';
    if (a && a.img) {
      var Wi = c.W * 12, Hi = c.H * 12; var g = geom(a, Wi, Hi);
      var sc = $('[data-abb-scale]');
      var pct = Math.round(100 * g.w / g.fillW);
      sc.value = String(Math.max(10, Math.min(400, pct)));
      $('[data-abb-scale-out]').textContent = pct + '%';
      $('[data-abb-bg]').value = a.bg;
      if (a.kind === 'image' && !/svg/i.test(a.file.type || a.name)) {
        var dpi = Math.round(a.natW / g.w);
        if (dpi < 25) { rw.hidden = false; rw.textContent = 'This image is about ' + dpi + ' pixels per inch at this size, so it will print blurry. Use a bigger image or a PDF, or let us design it.'; }
        else if (dpi < 50) { rw.hidden = false; rw.textContent = 'This image is about ' + dpi + ' pixels per inch at this size. It looks fine from a distance but soft up close. 100 or more is best.'; }
      }
    }
  }

  // ---------- render ----------
  function specLines(c, p) {
    var out = [];
    out.push(['Size', fmt(c.W) + ' ft \u00D7 ' + fmt(c.H) + ' ft (' + ftIn(c.W) + ' \u00D7 ' + ftIn(c.H) + ' in)']);
    out.push(['Material', c.mat.name]);
    out.push(['Sides', c.sides === 2 ? 'Double-sided' : 'Single-sided']);
    if (c.mat.backlit) out.push(['Color profile', labelOf(PROFS, c.prof) + (c.prof === 'night' ? ' (night-time use)' : ' (day-time use)')]);
    if (c.mat.poleBanner) out.push(['Hardware', c.hw === 'kit' ? 'Banner + Hardware (bracket kit for a ' + fmt(c.W * 12) + ' in wide banner)' : 'Banner Only']);
    var hang = [];
    if (c.pole !== 'none') hang.push('Pole pocket' + (c.pole === 'tb' ? 's top and bottom' : ' on top') + ', ' + c.poleSize + ' in');
    if (c.grommet !== 'none' && (c.pole === 'none' || c.mat.poleBanner)) hang.push('Grommets: ' + labelOf(GROMMETS, c.grommet).toLowerCase());
    if (c.webbing !== 'none') hang.push(labelOf(WEBBINGS, c.webbing));
    if (c.rope !== 'none') hang.push(labelOf(ROPES, c.rope));
    if (c.slits) hang.push('Wind slits');
    if (c.corners) hang.push('Reinforced corners');
    out.push(['Finishing', hang.length ? hang.join(', ') : 'None']);
    if (S.design) out.push(['Design', 'Ardor designs it (+$' + DESIGN_FEE + ')']);
    out.push(['Quantity', String(c.qty) + (p.disc ? ' (' + Math.round(p.disc * 100) + '% off)' : '')]);
    return out;
  }

  // v3-v3: extra option rows (pole banner hardware, backlit color profile)
  function extraRow(key, label) {
    var box = $('[data-abb-' + key + ']');
    if (!box) { box = document.createElement('div'); box.className = 'abb-opts abb-opts--two'; box.setAttribute('data-abb-' + key, ''); }
    var rowsEl = root.querySelector('.abx-rows');
    var sidesRow = rowsEl && rowsEl.querySelector('[data-abx-row="sides"]');
    if (sidesRow) {
      if (!box.closest('.abx-rows')) {
        var old = box.closest('[data-abb-x-wrap]');
        var r = document.createElement('div');
        r.className = 'abx-row';
        r.setAttribute('data-abx-row', key);
        r.setAttribute('data-abx-x', '1');
        r.innerHTML = '<span class="abx-row__label">' + esc(label) + '</span>';
        r.appendChild(box);
        var after = sidesRow;
        while (after.nextElementSibling && after.nextElementSibling.hasAttribute('data-abx-x')) after = after.nextElementSibling;
        rowsEl.insertBefore(r, after.nextElementSibling);
        if (old) old.parentNode.removeChild(old);
      }
    } else if (!box.parentNode) {
      var note = $('[data-abb-sides-note]');
      var wrap = document.createElement('div');
      wrap.setAttribute('data-abb-x-wrap', key);
      wrap.innerHTML = '<h3 class="abb-sub">' + esc(label) + '</h3>';
      wrap.appendChild(box);
      note.parentNode.insertBefore(wrap, note.nextSibling);
    }
    return box;
  }
  function showExtraRow(box, on) { var host = box.closest('.abx-row') || box.closest('[data-abb-x-wrap]') || box; host.hidden = !on; }
  function renderExtraRows(c) {
    var hw = extraRow('hw', 'Hardware');
    showExtraRow(hw, !!c.mat.poleBanner);
    if (c.mat.poleBanner) {
      var kit = money(poleKit(c));
      fill(hw, HWS.map(function (o) {
        return optBtn({ on: c.hw === o[0], data: { 'abb-hw': o[0] }, html: '<span class="abb-opt__name">' + esc(o[1]) + '</span><span class="abb-opt__sub">' + esc(o[2]) + (o[0] === 'kit' ? ' (+' + kit + ')' : '') + '</span>', pick: function () { set({ hw: o[0] }); } });
      }));
    }
    var pf = extraRow('prof', 'Color profile');
    showExtraRow(pf, !!c.mat.backlit);
    if (c.mat.backlit) {
      fill(pf, PROFS.map(function (o) {
        return optBtn({ on: c.prof === o[0], data: { 'abb-prof': o[0] }, html: '<span class="abb-opt__name">' + esc(o[1]) + '</span><span class="abb-opt__sub">' + esc(o[2]) + '</span>', pick: function () { set({ prof: o[0] }); } });
      }));
    }
  }

  function render() {
    var c = cfg();
    var p = price(c);
    var prob = problems(c);

    // size
    var wI = $('[data-abb-w]'), hI = $('[data-abb-h]');
    if (document.activeElement !== wI) wI.value = S.w;
    if (document.activeElement !== hI) hI.value = S.h;
    $('[data-abb-size-help]').textContent = fmt(c.W * c.H) + ' sq ft. Use decimals for inches, for example 2.5 ft is 2 ft 6 in.';
    fill($('[data-abb-sizes]'), (c.mat.poleBanner ? POLE_BANNER_SIZES : SIZES).map(function (wh) {
      return optBtn({ chip: true, on: c.W === wh[0] && c.H === wh[1], label: c.mat.poleBanner ? (fmt(wh[0] * 12) + ' \u00D7 ' + fmt(wh[1] * 12) + ' in') : (wh[0] + ' \u00D7 ' + wh[1] + ' ft' + (wh[1] > wh[0] ? ' (tall)' : '')), pick: function () { set({ w: String(wh[0]), h: String(wh[1]) }); } });
    }));

    // materials with live price for this size
    fill($('[data-abb-mats]'), MATS.map(function (m) {
      var mc = cfg({ mat: m.id });
      var mp = price(mc);
      var bad = problems(mc);
      var html = '<span class="abb-opt__name">' + esc(m.name) + '</span><span class="abb-opt__sub">' + esc(m.sub) + '</span><span class="abb-opt__price">' + (bad ? 'Not in this size' : money(mp.charged) + (mc.qty > 1 ? ' for ' + mc.qty : '')) + '</span>';
      return optBtn({ on: m.id === c.mat.id, html: html, data: { 'abb-mat': m.id }, pick: function () { var patch = { mat: m.id }; if (m.poleBanner && problems(cfg({ mat: m.id }))) { patch.w = '2'; patch.h = '3'; } set(patch); } });
    }));

    // sides
    var canDS = c.mat.canDS;
    fill($('[data-abb-sides]'), [
      optBtn({ on: c.sides === 1, disabled: !!c.mat.forceDS, data: { 'abb-side': '1' }, html: '<span class="abb-opt__name">Single-sided</span><span class="abb-opt__sub">' + (c.mat.forceDS ? 'Not on this product' : 'Printed on the front') + '</span>', pick: function () { set({ sides: 1 }); } }),
      optBtn({ on: c.sides === 2, disabled: !canDS, data: { 'abb-side': '2' }, html: '<span class="abb-opt__name">Double-sided</span><span class="abb-opt__sub">' + (canDS ? 'Printed on both sides' : 'Not on this material') + '</span>', pick: function () { set({ sides: 2 }); } })
    ]);
    var note = 'Printed on the front. The back is plain.';
    if (c.mat.poleBanner) note = 'Pole banners are 18oz blockout vinyl printed on both sides, so they read from either direction.';
    else if (!canDS) note = c.mat.name + ' is single-sided only.';
    else if (c.sides === 2) note = c.mat.id === 'mesh' ? 'Double-sided mesh needs a hem and can\'t have rope.' : 'Double-sided banners use heavy blockout vinyl so nothing shows through. No hem unless you add webbing.';
    $('[data-abb-sides-note]').textContent = note;
    renderExtraRows(c);

    // edges
    $('[data-abb-hem-label]').textContent = hemLabel(c);
    var poleOn = c.pole !== 'none';
    fill($('[data-abb-grommets]'), GROMMETS.map(function (g) {
      return optBtn({ chip: true, on: c.grommet === g[0], disabled: c.mat.poleBanner ? g[0] !== 'corners' : poleOn, data: { 'abb-grom': g[0] }, label: g[1], pick: function () { set({ grommet: g[0] }); } });
    }));
    $('[data-abb-grommet-note]').hidden = !poleOn || !!c.mat.poleBanner;
    $('[data-abb-pole-wrap]').hidden = !c.mat.canPole;
    fill($('[data-abb-poles]'), POLES.map(function (o) { return optBtn({ chip: true, on: c.pole === o[0], disabled: !!c.mat.poleBanner && o[0] !== 'tb', data: { 'abb-pole': o[0] }, label: o[1], pick: function () { set({ pole: o[0] }); } }); }));
    var ps = $('[data-abb-pole-sizes]'); ps.hidden = !poleOn;
    fill(ps, POLE_SIZES.filter(function (o) { return !c.mat.poleSizes || c.mat.poleSizes.indexOf(o[0]) >= 0; }).map(function (o) { return optBtn({ chip: true, on: c.poleSize === o[0], data: { 'abb-ps': String(o[0]) }, label: o[1], pick: function () { set({ poleSize: o[0] }); } }); }));

    // extras
    var showRope = c.mat.canRope && !poleOn && !(c.mat.id === 'mesh' && c.sides === 2);
    $('[data-abb-extras-wrap]').hidden = !(c.mat.canWeb || c.mat.canRope || c.mat.canSlits || c.mat.canCorners);
    $('[data-abb-webbing-wrap]').hidden = !c.mat.canWeb;
    fill($('[data-abb-webbings]'), WEBBINGS.map(function (o) { return optBtn({ chip: true, on: c.webbing === o[0], data: { 'abb-web': o[0] }, label: o[1], pick: function () { set({ webbing: o[0] }); } }); }));
    $('[data-abb-rope-wrap]').hidden = !showRope;
    fill($('[data-abb-ropes]'), ROPES.map(function (o) { return optBtn({ chip: true, on: c.rope === o[0], data: { 'abb-rope': o[0] }, label: o[1], pick: function () { set({ rope: o[0] }); } }); }));
    var toggles = [];
    if (c.mat.canSlits) toggles.push(optBtn({ chip: true, on: c.slits, data: { 'abb-slits': c.slits ? 'off' : 'on' }, label: 'Wind slits', pick: function () { set({ slits: !S.slits }); } }));
    if (c.mat.canCorners) toggles.push(optBtn({ chip: true, on: c.corners, data: { 'abb-corners': c.corners ? 'off' : 'on' }, label: 'Reinforced corners', pick: function () { set({ corners: !S.corners }); } }));
    fill($('[data-abb-toggles]'), toggles);

    // quantity
    var qI = $('[data-abb-qty]');
    if (document.activeElement !== qI) qI.value = String(c.qty);
    $('[data-abb-disc-label]').textContent = c.qty >= 10 ? '10% off 10 or more' : (c.qty >= 3 ? '5% off 3 or more' : 'Save 5% on 3 or more, 10% on 10 or more');

    // design brief
    $('[data-abb-design-brief-wrap]').hidden = !S.design;

    // price box
    var inTable = !priceTable || (p.unit >= priceTable.min && p.unit <= priceTable.max);
    var tooBig = priceTable && p.unit > priceTable.max;
    $('[data-abb-total]').textContent = prob ? '\u2014' : money(p.charged);
    $('[data-abb-mbar-total]').textContent = prob ? '\u2014' : money(p.charged);
    $('[data-abb-dbar-total]').textContent = prob ? '\u2014' : money(p.charged);
    var eachEl = $('[data-abb-each]');
    eachEl.hidden = c.qty < 2 || !!prob;
    eachEl.textContent = money(p.unit) + ' each \u00D7 ' + c.qty;
    var specs = $('[data-abb-specs]'); specs.textContent = '';
    specLines(c, p).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); });
    var warn = $('[data-abb-warn]');
    var wtxt = prob || (tooBig ? 'This banner is bigger than we can order online. Request a quote and we\'ll price it by hand.' : '');
    warn.hidden = !wtxt; warn.textContent = wtxt;
    var addOk = !prob && inTable;
    $('[data-abb-add]').disabled = !addOk;
    $('[data-abb-add-m]').disabled = !addOk;
    $('[data-abb-add-d]').disabled = !addOk;

    // viewer chips and tools
    $('[data-abb-chip-size]').textContent = fmt(c.W) + ' ft \u00D7 ' + fmt(c.H) + ' ft';
    $('[data-abb-chip-mat]').textContent = c.mat.name;
    $('[data-abb-chip-sides]').textContent = c.sides === 2 ? 'Double-sided' : 'Single-sided';
    var lightsBtn = $('[data-abb-lights]');
    lightsBtn.hidden = !c.mat.backlit;
    lightsBtn.setAttribute('aria-pressed', S.lights ? 'true' : 'false');
    $('[data-abb-wind]').setAttribute('aria-pressed', S.wind ? 'true' : 'false');
    $('[data-abb-flip]').textContent = S.back ? 'Show front' : 'Show back';
    $('[data-abb-viewer]').classList.toggle('is-dark', !!(c.mat.backlit && S.lights));

    updateArtUi();
    drawLayout();
    if (eng) eng.sync(c);
  }

  // ---------- 3D viewer ----------
  function startEngine() {
    var canvas = $('[data-abb-canvas]');
    var host = { view: view, paintArt: function (ctx, Wi, Hi, face) { return paintFace(ctx, Wi, Hi, face); }, artImage: null };
    try { eng = window.ArdorBanner3D ? window.ArdorBanner3D.create(canvas, host) : null; } catch (e) { eng = null; }
    if (!eng) { $('[data-abb-nogl]').hidden = false; $('[data-abb-hint]').hidden = true; return; }
    eng.sync(cfg());
    var vw = $('[data-abb-viewer]');
    var hint = $('[data-abb-hint]');
    var touched = 0;
    var pinch = {};
    canvas.addEventListener('pointerdown', function (e) {
      view.drag = true; view.lx = e.clientX; view.ly = e.clientY; view.lastInput = performance.now(); touched = performance.now();
      view.touch = e.pointerType === 'touch';
      vw.classList.add('is-dragging'); hint.classList.add('is-gone');
      if (!view.touch) { try { canvas.setPointerCapture(e.pointerId); } catch (er) {} }
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!view.drag) return;
      var dx = e.clientX - view.lx, dy = e.clientY - view.ly;
      view.lx = e.clientX; view.ly = e.clientY;
      view.yaw += dx * 0.009;
      if (!view.touch) view.pitch = Math.max(-0.45, Math.min(0.55, view.pitch + dy * 0.005));
      view.lastInput = performance.now();
    });
    var up = function () { view.drag = false; vw.classList.remove('is-dragging'); };
    canvas.addEventListener('pointerup', up); canvas.addEventListener('pointercancel', up); canvas.addEventListener('pointerleave', up);
    canvas.addEventListener('wheel', function (e) {
      if (!(e.ctrlKey || performance.now() - touched < 4000)) return;
      e.preventDefault();
      view.zoom = Math.max(0.6, Math.min(4, view.zoom * Math.exp(-e.deltaY * 0.0012))); view.lastInput = performance.now(); touched = performance.now();
    }, { passive: false });
    canvas.addEventListener('touchstart', function (e) { if (e.touches.length === 2) { pinch.d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); pinch.z = view.zoom; } }, { passive: true });
    canvas.addEventListener('touchmove', function (e) { if (e.touches.length === 2 && pinch.d) { var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); view.zoom = Math.max(0.6, Math.min(4, pinch.z * d / pinch.d)); view.lastInput = performance.now(); } }, { passive: true });
    canvas.addEventListener('touchend', function () { pinch.d = 0; }, { passive: true });
  }

  // ---------- proof sheet and print files ----------
  function slitsFor(Wi, Hi) {
    var out = [], row = 0;
    for (var y = 12; y <= Hi - 12; y += 20) { var off = (row++ % 2) * 12; for (var x = 14 + off; x <= Wi - 14; x += 24) out.push([x, y]); }
    return out;
  }

  function proofCanvas(face, overlayOnly) {
    var c = cfg(), Wi = c.W * 12, Hi = c.H * 12;
    var long = 1800, cw, ch;
    if (Wi >= Hi) { cw = long; ch = Math.max(60, Math.round(long * Hi / Wi)); } else { ch = long; cw = Math.max(60, Math.round(long * Wi / Hi)); }
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cw / Wi, 0, 0, ch / Hi, 0, 0);
    var drewArt = overlayOnly || (!S.design && paintFace(ctx, Wi, Hi, face === 'back' ? 'back-flat' : 'front'));
    if (overlayOnly && hasLayers(layerFace(face === 'back' ? 'back-flat' : 'front'))) window.ArdorBannerLayers.paint(ctx, Wi, Hi, layerFace(face === 'back' ? 'back-flat' : 'front')); // v3
    if (!drewArt) {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#5E5A55'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.max(2, Math.min(Hi * 0.1, Wi * 0.05)) + 'px Arial, sans-serif';
      ctx.fillText(S.design ? 'Ardor designs your artwork' : 'Your artwork', Wi / 2, Hi / 2);
    }
    var b = bands(c), u = Math.max(Wi, Hi) / cw;
    var dashLine = function (x1, y1, x2, y2) {
      ctx.setLineDash([]); ctx.lineWidth = u * 3; ctx.strokeStyle = 'rgba(255,255,255,0.85)';
      ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
      ctx.setLineDash([u * 9, u * 6]); ctx.lineWidth = u * 1.6; ctx.strokeStyle = 'rgba(15,15,15,0.95)';
      ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
      ctx.setLineDash([]);
    };
    var label = function (txt, x, y) {
      var fs = Math.max(u * 11, Math.min(Hi * 0.035, 3));
      ctx.font = '700 ' + fs + 'px Arial, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var tw = ctx.measureText(txt).width;
      ctx.fillStyle = 'rgba(255,255,255,0.88)'; ctx.fillRect(x - tw / 2 - fs * 0.4, y - fs * 0.7, tw + fs * 0.8, fs * 1.4);
      ctx.fillStyle = '#0C0D0D'; ctx.fillText(txt, x, y);
    };
    ctx.save();
    if (c.pole !== 'none') { ctx.fillStyle = 'rgba(12,13,13,0.10)'; ctx.fillRect(0, 0, Wi, b.top); if (c.pole === 'tb') ctx.fillRect(0, Hi - b.bottom, Wi, b.bottom); }
    if (b.top) dashLine(0, b.top, Wi, b.top);
    if (b.bottom) dashLine(0, Hi - b.bottom, Wi, Hi - b.bottom);
    if (b.side) { dashLine(b.side, 0, b.side, Hi); dashLine(Wi - b.side, 0, Wi - b.side, Hi); }
    if (c.pole !== 'none') { label('POLE POCKET (' + c.poleSize + ' IN)', Wi / 2, b.top / 2); if (c.pole === 'tb') label('POLE POCKET (' + c.poleSize + ' IN)', Wi / 2, Hi - b.bottom / 2); }
    if (c.webbing !== 'none') { ctx.lineWidth = u * 2.5; ctx.strokeStyle = 'rgba(12,13,13,0.55)'; ctx.setLineDash([u * 4, u * 3]); ctx.strokeRect(0.35, 0.35, Wi - 0.7, Hi - 0.7); ctx.setLineDash([]); }
    if (c.corners) {
      [[0, 0, 1, 1], [Wi, 0, -1, 1], [0, Hi, 1, -1], [Wi, Hi, -1, -1]].forEach(function (k) {
        ctx.beginPath(); ctx.moveTo(k[0], k[1]); ctx.lineTo(k[0] + k[2] * 4.5, k[1]); ctx.lineTo(k[0], k[1] + k[3] * 4.5); ctx.closePath();
        ctx.fillStyle = 'rgba(255,255,255,0.45)'; ctx.fill(); ctx.lineWidth = u * 1.5; ctx.strokeStyle = 'rgba(12,13,13,0.7)'; ctx.stroke();
      });
    }
    if (c.slits) {
      ctx.lineWidth = Math.max(u * 2, 0.15); ctx.strokeStyle = 'rgba(12,13,13,0.85)';
      slitsFor(Wi, Hi).forEach(function (pt) { ctx.beginPath(); ctx.arc(pt[0], pt[1], 3, 0.12 * Math.PI, 0.88 * Math.PI); ctx.stroke(); });
    }
    holes(c, Wi, Hi).forEach(function (pt) {
      var r = Math.max(0.5, u * 5);
      ctx.beginPath(); ctx.arc(pt[0], pt[1], r, 0, Math.PI * 2); ctx.fillStyle = '#A9ADB1'; ctx.fill();
      ctx.lineWidth = r * 0.18; ctx.strokeStyle = '#4A4D51'; ctx.stroke();
      ctx.beginPath(); ctx.arc(pt[0], pt[1], r * 0.45, 0, Math.PI * 2); ctx.fillStyle = '#FFFFFF'; ctx.fill();
    });
    ctx.lineWidth = u * 2; ctx.strokeStyle = '#0C0D0D'; ctx.strokeRect(0, 0, Wi, Hi);
    ctx.restore();
    return cv;
  }

  function geomForArt(a, nw, nh, Wi, Hi) {
    var ia = nw / nh, ba = Wi / Hi;
    if (a.kind !== 'image' && !a.img) {
      if (Math.abs(ia - ba) / ba < 0.01) return { x: 0, y: 0, w: Wi, h: Hi };
      var fw = Math.min(Wi, Hi * ia), fh = fw / ia;
      return { x: (Wi - fw) / 2, y: (Hi - fh) / 2, w: fw, h: fh, note: 'The uploaded PDF is a different shape than the banner, so it was placed to fit, centered, with white around it.' };
    }
    var fillW = Math.max(Wi, Hi * ia), fitW = Math.min(Wi, Hi * ia);
    var w = a.mode === 'fill' ? fillW : (a.mode === 'fit' ? fitW : a.rw * Wi);
    var cx = a.mode === 'custom' ? a.rcx * Wi : Wi / 2, cy = a.mode === 'custom' ? a.rcy * Hi : Hi / 2, h = w / ia;
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h };
  }

  function loadPdfTool() {
    if (window.ArdorBannerPDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
      sc.onload = function () { res(); }; sc.onerror = function () { rej(new Error('pdf tool')); };
      document.head.appendChild(sc);
    });
  }

  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }

  function proofSpecs(c) {
    var yn = function (v) { return v ? 'Yes' : 'No'; };
    var out = [
      ['Size', fmt(c.W) + ' ft \u00D7 ' + fmt(c.H) + ' ft (' + ftIn(c.W) + ' \u00D7 ' + ftIn(c.H) + ' in)'],
      ['Material', c.mat.name],
      ['Printed sides', c.sides === 2 ? 'Double-sided' : 'Single-sided'],
      ['Hem', hemLabel(c).replace(/\.$/, '').replace(/^./, function (m) { return m.toUpperCase(); })],
      ['Grommets', c.pole !== 'none' && !c.mat.poleBanner ? 'None (pole pockets)' : labelOf(GROMMETS, c.grommet)],
      ['Pole pockets', c.pole === 'none' ? 'None' : (labelOf(POLES, c.pole) + ', ' + labelOf(POLE_SIZES, c.poleSize))],
      ['Webbing', labelOf(WEBBINGS, c.webbing) || 'None'],
      ['Rope', labelOf(ROPES, c.rope) || 'None']
    ];
    if (c.mat.canSlits) out.push(['Wind slits', yn(c.slits)]);
    if (c.mat.canCorners) out.push(['Reinforced corners', yn(c.corners)]);
    if (c.mat.backlit) out.push(['Color profile', labelOf(PROFS, c.prof) + (c.prof === 'night' ? ' (night-time use)' : ' (day-time use)')]);
    if (c.mat.poleBanner) out.push(['Hardware', c.hw === 'kit' ? 'Banner + Hardware (bracket kit: 2 fiberglass poles, 2 brackets, 4 steel bands)' : 'Banner Only (no brackets)']);
    out.push(['Quantity', String(c.qty)]);
    out.push(['Delivery', S.delivery === 'pickup' ? 'Pick up at our Snohomish shop' : 'Ship (free ground)']);
    out.push(['Artwork', S.design ? 'Ardor designs it' + (ART.front ? ' (reference: ' + ART.front.name + ')' : '') : (ART.front ? ART.front.name : 'None')]);
    var pl = !S.design && placementText(ART.front, c); if (pl) out.push(['Placement', pl]);
    if (c.sides === 2) out.push(['Back', S.backMode === 'different' ? (ART.back ? ART.back.name : 'Different art') : 'Same as front']);
    var added = layerSummary(c); if (added) out.push(['Added in the builder', added]); // v3
    var brief = ($('[data-abb-design-brief]').value || '').trim(); if (S.design && brief) out.push(['Design brief', brief]);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
    return out;
  }

  // ---------- proof sheet shared by the builders (assets/ardor-proofsheet.js, Oct 9 2026): the 3D view on page 1, the print file next to it or on page 2 ----------
function proofViews(c) {
var out = [];
if (!eng || typeof eng.snapshot !== 'function') return out;
try { eng.sync(c); } catch (e) {}
[['home', 'From the front'], ['back', 'From the back']].forEach(function (v) {
try { var cv = eng.snapshot(1000, 1030, v[0]); if (cv) out.push({ canvas: cv, caption: v[1] }); } catch (e) {}
});
return out;
}
function proofSheet(P, c, mode, o) {
var PS = window.ArdorProofSheet;
if (!PS || typeof PS.build !== 'function') return P.buildProof(o);
o.noun = 'banner'; o.kind = 'banner'; o.panelTitle = o.panelTitle || 'Your banner'; o.preview = mode === 'preview'; o.views = proofViews(c);
return PS.build(o).catch(function () { return P.buildProof(o); });
}
function buildFiles(c, approval, proofMode) {
    return loadPdfTool().then(function () {
      var P = window.ArdorBannerPDF, Wi = c.W * 12, Hi = c.H * 12;
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var out = { notes: [], proof: null, plain: null, dots: null, scale: 1 };
      var dimW = fmt(Wi) + ' in (' + fmt(c.W) + ' ft)', dimH = fmt(Hi) + ' in (' + fmt(c.H) + ' ft)';
      // the file used for vector drawing: the PDF/AI itself, or the PDF made from an EPS
      var vectorArt = function (a) {
        if (S.design || !a || a.kind === 'image') return null;
        if (a.src === 'eps' && a.vectorPdf) return { file: new File([a.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }), name: 'artwork.pdf' };
        if (a.src === 'pdf' || a.src === 'ai' || (!a.src && (/\.(pdf|ai)$/i.test(a.name) || /pdf/i.test(a.file.type || '')))) return a;
        return null;
      };
      var mkProofFace = function (label, faceKey, a) {
        var va = vectorArt(a);
        return { label: label, canvas: proofCanvas(faceKey, !!va), fallback: va ? proofCanvas(faceKey, false) : null, wIn: Wi, hIn: Hi, wLabel: dimW, hLabel: dimH, underlay: va ? { art: va, bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } } : null };
      };
      var faces = [mkProofFace(c.sides === 2 ? (backDiff ? 'Front' : 'Front (same art on the back)') : 'Front', 'front', ART.front)];
      if (backDiff) faces.push(mkProofFace('Back', 'back', ART.back));
      var date = (approval && approval.when) || stampLabel(new Date());
      var proofP = logoImage().then(function (logo) {
        return proofSheet(P, c, proofMode, { logo: logo, title: 'Ardor Banner Proof', approval: approval || null, date: date, faces: faces, specs: proofSpecs(c), note: 'Print size ' + fmt(Wi) + ' \u00D7 ' + fmt(Hi) + ' in, no bleed.', footer: 'Ardor Printing  |  12531 Old Snohomish Monroe Rd., Snohomish, WA 98290  |  (425) 629-0796  |  ardorprinting.com' });
      }).catch(function () { return null; });
      var arts = [ART.front]; if (backDiff) arts.push(ART.back);
      var printable = function (a, i) { return a ? (a.kind === 'image' || !!vectorArt(a)) : hasLayers(i ? 'back' : 'front'); }; // v3: text-only faces print too
      var printP = Promise.resolve();
      if (proofMode === 'preview') { /* PDF button: the proof only, no print files */ } else if (S.design) out.notes.push('Ardor designs the artwork: make print files after the customer approves the design.');
      else if (!arts.every(printable)) out.notes.push('Print files were not made automatically for this file type. Use the original artwork file.');
      else {
        if (arts.some(function (a) { return a && a.src === 'eps'; })) out.notes.push('The customer uploaded an EPS. The print file was made from it by the online converter, so check it against the original EPS before printing.');
        var job = { title: 'Ardor Banner Print File', stamp: date, W: c.W, H: c.H, holes: holes(c, Wi, Hi), dotIn: 0.125, faces: arts.map(function (a) { return !a ? null : { art: a.kind === 'image' ? a : vectorArt(a), bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } }; }) };
        printP = layerPrintFaces(job, arts, Wi, Hi, out.notes).then(function () { return P.buildPrint(job, false); }).then(function (r) { // v3
          out.plain = r.blob; out.scale = r.scale; r.notes.forEach(function (n) { if (out.notes.indexOf(n) < 0) out.notes.push(n); });
          if (!job.holes.length) return null;
          return P.buildPrint(job, true).then(function (r2) { out.dots = r2.blob; });
        }).catch(function (e) { out.plain = null; out.dots = null; out.notes.push('Print files could not be made automatically (' + ((e && e.message) || 'error') + '). Use the original artwork file.'); });
      }
      return Promise.all([proofP, printP]).then(function (r) { out.proof = r[0]; return out; });
    });
  }

  // ---------- cart ----------
  function loadPrices() {
    if (priceTable) return Promise.resolve(priceTable);
    return fetch(CONF.pricesUrl, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('prices'); return r.json(); }).then(function (j) { priceTable = j; render(); return j; });
  }

  function placementText(a, c) {
    if (!a || !a.img) return '';
    if (a.mode === 'fill') return 'Fill banner (edges may crop)';
    if (a.mode === 'fit') return 'Fit whole image, background ' + a.bg;
    if (a.tpl && a.mode === 'custom' && a.rw === a.tpl.rw && a.rcx === 0.5 && a.rcy === 0.5 && window.ArdorBannerTemplate && window.ArdorBannerTemplate.spec(c).key === a.tpl.key) return 'Ardor template file, placed edge to edge (the ' + fmt(a.tpl.bleed) + ' in bleed is trimmed off), background ' + a.bg;
    var Wi = c.W * 12, Hi = c.H * 12; var g = geom(a, Wi, Hi);
    return 'Custom: art ' + fmt(g.w) + ' \u00D7 ' + fmt(g.h) + ' in, top-left at ' + fmt(g.x) + ', ' + fmt(g.y) + ' in from banner top-left, background ' + a.bg;
  }

  function toast(msg) {
    var t = $('[data-abb-toast]'); t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    // disabled Oct 18 2026 – duplicate of Shopify Google & YouTube / Facebook app event (add_to_cart / AddToCart). The generate_lead / Lead branch fired on the "Go to the quote form" link click, not on a sent lead; the lead itself is the HubSpot form submit, which GTM already sends as generate_lead + the Google Ads quote conversion. The dataLayer push above stays. Undo: remove "// " from the next 2 lines.
    // try { if (window.gtag) window.gtag('event', name === 'ardor_banner_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    // try { if (window.fbq) window.fbq('track', name === 'ardor_banner_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  function openApproval(c) {
    return new Promise(function (resolve, reject) {
      approveCtl = { resolve: resolve, reject: reject };
      var box = $('[data-abb-approve-proof]'); box.textContent = '';
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var faces = [[c.sides === 2 ? (backDiff ? 'Front' : 'Front (same art on the back)') : 'Front', 'front', ART.front]];
      if (backDiff) faces.push(['Back', 'back', ART.back]);
      faces.forEach(function (f) {
        var cv = proofCanvas(f[1], false);
        var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
        var im = new Image(); im.alt = f[0] + ' of your banner proof'; im.src = cv.toDataURL('image/jpeg', 0.86);
        var cap = document.createElement('figcaption');
        var isFile = f[2] && f[2].kind !== 'image';
        cap.textContent = f[0] + ': ' + fmt(c.W * 12) + ' \u00D7 ' + fmt(c.H * 12) + ' in' + (isFile ? '. We print from your original file (' + f[2].name + ').' : '');
        fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
      });
      var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
      proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
      $('[data-abb-approve-error]').hidden = true;
      $('[data-abb-ap-colors]').checked = false;
      var dlg = $('[data-abb-approve]');
      loadSigFont();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      setSigMode(coarse ? 'draw' : 'type');
    });
  }
  function submitApproval(e) {
    var AL = window.ArdorArtLink; if (AL && AL.emailChosen(root)) { e.preventDefault(); var pe = AL.proofEmail(root); if (pe) closeApproval({ emailProof: true, email: pe }); return; } // ART0 Oct 19 2026: "Email me the proof to approve"
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
    var copy;
    if (mode === 'type') copy = typedSigCanvas(typed);
    else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
    closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // v3-v2 (Oct 12, 2026): the cart refuses any add-to-cart request over 20 MB ("413 Request Entity Too Large"), and this
  // request holds the proof, the print file, its copy with grommet dots and the customer's original upload(s).
  // Keep the whole upload under UPLOAD_BUDGET: the proof and the print file first (made smaller only when they alone are
  // too big), then the grommet-dot copy (made smaller when needed, or left out), then the original files while they fit.
  // Every change is written in the hidden "_Print file note" property.
  var UPLOAD_BUDGET = 18 * 1024 * 1024;
  function fmtMB(n) { return (n / 1048576).toFixed(1) + ' MB'; }
  function decodeBlob(file) {
    if (window.createImageBitmap) return createImageBitmap(file);
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () { res(im); };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('could not read the print image')); };
      im.src = u;
    });
  }
  // re-encode a JPEG/PNG smaller (fewer pixels, then lower quality) until it is at most maxBytes
  function shrinkImage(file, maxBytes) {
    if (!file || file.size <= maxBytes) return Promise.resolve(file);
    return decodeBlob(file).then(function (bmp) {
      var bw = bmp.naturalWidth || bmp.width, bh = bmp.naturalHeight || bmp.height;
      var scale = Math.min(1, Math.sqrt(maxBytes / file.size) * 0.95), q = 0.9, tries = 0;
      var attempt = function () {
        var w = Math.max(1, Math.round(bw * scale)), h = Math.max(1, Math.round(bh * scale));
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var ctx = cv.getContext('2d');
        if (!ctx) return Promise.reject(new Error('canvas'));
        ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, w, h);
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(bmp, 0, 0, w, h);
        return new Promise(function (res) { cv.toBlob(res, 'image/jpeg', q); }).then(function (b) {
          cv.width = cv.height = 1;
          if (!b) throw new Error('could not make the print image');
          if (b.size > maxBytes && tries < 5) { tries++; scale *= Math.sqrt(maxBytes / b.size) * 0.95; q = Math.max(0.8, q - 0.03); return attempt(); }
          if (bmp.close) bmp.close();
          return new File([b], String(file.name || 'Ardor Banner Print Art').replace(/\.[A-Za-z0-9]{1,5}$/, '') + '.jpg', { type: 'image/jpeg' });
        });
      };
      return attempt();
    });
  }
  // the print job again, every face as one flattened image (artwork plus text and clipart) of at most share bytes
  function smallerJob(c, share, approval) {
    var LY = window.ArdorBannerLayers, Wi = c.W * 12, Hi = c.H * 12;
    if (!LY || !LY.composite) return Promise.reject(new Error('print tools not loaded'));
    var arts = [ART.front]; if (c.sides === 2 && S.backMode === 'different') arts.push(ART.back);
    var date = (approval && approval.when) || stampLabel(new Date());
    return Promise.all(arts.map(function (a, i) {
      var f = i ? 'back' : 'front';
      if (!a && !hasLayers(f)) return null;
      return LY.composite(f, Wi, Hi, a).then(function (r) { return shrinkImage(r.file, share); }).then(function (file) {
        return { art: { file: file, name: file.name, kind: 'image' }, bg: (a && a.bg) || '#FFFFFF', geomFor: function () { return { x: 0, y: 0, w: Wi, h: Hi }; } };
      });
    })).then(function (faces) { return { title: 'Ardor Banner Print File', stamp: date, W: c.W, H: c.H, holes: holes(c, Wi, Hi), dotIn: 0.125, faces: faces }; });
  }
  function fitUpload(c, files, approval) {
    var P = window.ArdorBannerPDF, two = c.sides === 2 && S.backMode === 'different', faces = two ? ['front', 'back'] : ['front'], nf = faces.length;
    var size = function (b) { return b ? b.size : 0; };
    var orig = function (f) { return ART[f] && ART[f].file ? ART[f].file : null; };
    var wantDots = !!files.dots;
    files.skipArt = { front: false, back: false }; files.needEmail = false;
    var total = function () { return size(files.proof) + size(files.plain) + size(files.dots) + faces.reduce(function (t, f) { return t + (files.skipArt[f] ? 0 : size(orig(f))); }, 0); };
    if (total() <= UPLOAD_BUDGET || !P) return Promise.resolve(files);
    var room = function () { return UPLOAD_BUDGET - size(files.proof) - 262144; };
    var dotsOut = 'The print file with grommet dots was left out to fit the 20 MB online order upload limit. The grommet positions are on the proof.';
    var chain = Promise.resolve();
    // 1. the print file alone is too big: make it again from smaller flattened images
    if (files.plain && size(files.plain) > room()) chain = chain.then(function () {
      var was = size(files.plain), share = Math.max(1048576, Math.floor(room() / nf) - 131072);
      return smallerJob(c, share, approval).then(function (job) { return P.buildPrint(job, false); }).then(function (r) {
        if (!r || !r.blob || r.blob.size >= was) return null;
        files.plain = r.blob; files.scale = r.scale; files.dots = null;
        files.notes.push('The print file was made at a lower resolution (' + fmtMB(was) + ' to ' + fmtMB(r.blob.size) + ') to fit the 20 MB online order upload limit.');
      }).catch(function () { return null; });
    });
    // 2. the copy with grommet dots: kept when it fits, else made again from smaller images, else left out
    chain = chain.then(function () {
      if (!wantDots || !files.plain) return null;
      var left = room() - size(files.plain);
      if (files.dots && size(files.dots) <= left) return null;
      files.dots = null;
      var share = Math.floor((left - 131072) / nf);
      if (share < 1048576) { files.notes.push(dotsOut); return null; }
      return smallerJob(c, share, approval).then(function (job) { return P.buildPrint(job, true); }).then(function (r) {
        if (r && r.blob && r.blob.size <= left) { files.dots = r.blob; files.notes.push('The print file with grommet dots was made at a lower resolution (' + fmtMB(r.blob.size) + ') to fit the 20 MB online order upload limit. Print from the plain print file.'); }
        else files.notes.push(dotsOut);
      }, function () { files.notes.push(dotsOut); });
    });
    // 3. the customer's original files, while they still fit (last resort: leave out the dot copy, then the print file)
    return chain.then(function () {
      var attach = function () {
        var used = size(files.proof) + size(files.plain) + size(files.dots);
        faces.forEach(function (f) { var o = orig(f); files.skipArt[f] = false; if (!o) return; if (used + o.size <= UPLOAD_BUDGET) used += o.size; else files.skipArt[f] = true; });
      };
      attach();
      if (total() > UPLOAD_BUDGET && files.dots) { files.notes.push(dotsOut); files.dots = null; attach(); }
      if (size(files.proof) + size(files.plain) > UPLOAD_BUDGET) { files.notes.push('The print file (' + fmtMB(files.plain.size) + ') was too large to attach. Make it from the original artwork.'); files.plain = null; files.dots = null; attach(); }
      faces.forEach(function (f) {
        if (!files.skipArt[f]) return;
        var o = orig(f);
        if (!files.plain) files.needEmail = true;
        files.notes.push('The customer\'s original ' + (two ? f + ' ' : '') + 'file (' + (ART[f].name || 'artwork') + ', ' + fmtMB(o.size) + ') was not attached (over the 20 MB online order upload limit).' + (files.plain ? ' The print file has the full design.' : ' The customer was asked to email it.'));
      });
      return files;
    });
  }
  function addToCart() {
    showErr('');
    var c = cfg(); var p = price(c);
    var prob = problems(c);
    if (prob) { showErr(prob); return; }
    if (!S.delivery) {
      var fs = $('.abb-delivery'); fs.classList.add('is-missing');
      showErr('Choose how you want to get your banner: free shipping or free pickup in Snohomish.');
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var artLink = window.ArdorArtLink ? window.ArdorArtLink.link(root, ART.front && ART.front.file) : null; // ART0 Oct 19 2026: artwork by link
    if (!ART.front && !S.design && !hasLayers('front') && !artLink) { showErr('Upload your artwork, or check "Have Ardor design it".'); $('[data-abb-drop]').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    if (c.sides === 2 && S.backMode === 'different' && !ART.back && !S.design && !hasLayers('back')) { showErr('Upload the art for the back, or choose "Same art on both sides".'); return; }
    var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')];
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding\u2026'; });
    var done = function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); };
    var approval = null, emailProof = false, proofEmail = ''; // ART0: proofEmail
    var waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
    Promise.all(waits).then(function () { return loadPrices(); }).then(function (tbl) {
      if (p.unit < tbl.min || p.unit > tbl.max) throw new Error('This banner is bigger than we can order online. Please request a quote.');
      emailProof = needsEmailProof() || !!(artLink && !artLink.loaded); // ART0: a link we couldn't open = emailed proof
      return (emailProof ? Promise.resolve(null) : openApproval(c)).then(function (ap) { if (ap && ap.emailProof) { proofEmail = ap.email; emailProof = true; ap = null; } approval = ap; return tbl; }); // ART0: "Email me the proof to approve"
    }).then(function (tbl) {
      var vid = tbl.ids[p.unit - tbl.min];
      btns.forEach(function (b) { b.textContent = 'Saving your proof\u2026'; });
      return buildFiles(c, approval).then(function (files) { return fitUpload(c, files, approval); }).then(function (files) { // v3-v2: stay under the cart's 20 MB upload limit
        var fd = new FormData();
        fd.append('id', String(vid));
        fd.append('quantity', String(c.qty));
        specLines(c, p).forEach(function (l) { if (l[0] !== 'Quantity') fd.append('properties[' + l[0] + ']', l[1]); });
        fd.append('properties[Hem]', hemLabel(c).replace(/\.$/, ''));
        if (ART.front) fd.append('properties[Artwork]', ART.front.name);
        var pl = placementText(ART.front, c); if (pl) fd.append('properties[Art placement]', pl);
        if (c.sides === 2) fd.append('properties[Back artwork]', S.backMode === 'different' ? (ART.back ? ART.back.name : 'Ardor designs it') : 'Same as front');
        if (c.sides === 2 && S.backMode === 'different') { var pb = placementText(ART.back, c); if (pb) fd.append('properties[Back placement]', pb); }
        var brief = ($('[data-abb-design-brief]').value || '').trim();
        if (S.design && brief) fd.append('properties[Design brief]', brief);
        var notes = ($('[data-abb-notes]').value || '').trim();
        if (notes) fd.append('properties[Notes]', notes);
        fd.append('properties[Delivery]', S.delivery === 'pickup' ? 'Pick up in Snohomish (free)' : 'Ship it (free ground)');
        fd.append('properties[Price each]', money(p.unit) + ', includes free shipping');
        fd.append('properties[Designed in]', 'Ardor Banner Builder');
        if (artLink) fd.append('properties[Artwork link]', artLink.url); // ART0
        if (proofEmail || (artLink && !artLink.loaded)) fd.append('properties[Proof approval]', 'Email - pending'); // ART0
        if (proofEmail) fd.append('properties[Proof email]', proofEmail); // ART0
        var stampDate = approval && approval.at ? approval.at : new Date();
        var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
        var ext = function (n) { var m = /\.[A-Za-z0-9]{1,5}$/.exec(n || ''); return m ? m[0].toLowerCase() : ''; };
        var MAXPDF = 25 * 1024 * 1024;
        if (files.proof && approval) fd.append('properties[Ardor Banner Proof - ' + labelStamp + ']', new File([files.proof], 'Ardor Banner Proof ' + fileStamp + '.pdf', { type: 'application/pdf' }));
        else if (files.proof) fd.append('properties[_Ardor Banner Unsigned Proof - ' + labelStamp + ']', new File([files.proof], 'Ardor Banner Unsigned Proof ' + fileStamp + '.pdf', { type: 'application/pdf' }));
        if (!approval) fd.append('properties[Proof]', S.design ? 'We\'ll email your design proof to approve before printing' : (artLink && !artLink.loaded ? 'Ardor will build the proof from your link and email it to you to approve' : 'We\'ll email you a proof to approve before printing')); // ART0
        if (approval) {
          fd.append('properties[Approved by]', approval.name);
          fd.append('properties[Approved on]', approval.when);
          fd.append('properties[_Approver email]', approval.email);
          fd.append('properties[_Approver phone]', approval.phone);
        }
        if (files.plain && files.plain.size <= MAXPDF) fd.append('properties[_Ardor Banner Print File - ' + labelStamp + ']', new File([files.plain], 'Ardor Banner Print File ' + fileStamp + '.pdf', { type: 'application/pdf' }));
        else if (files.plain) files.notes.push('Print file was over 25 MB, so it was not attached. Use the original artwork file.');
        if (files.dots && files.dots.size <= MAXPDF) fd.append('properties[_Ardor Banner Print File with Grommet Dots - ' + labelStamp + ']', new File([files.dots], 'Ardor Banner Print File with Grommet Dots ' + fileStamp + '.pdf', { type: 'application/pdf' }));
        var pnote = [];
        if (files.plain) pnote.push('Exact finished size, no bleed' + (files.scale !== 1 ? ', built at 10% scale (PDF UserUnit 10) because the banner is over 200 in' : ', 100% scale') + '.' + (files.dots ? ' Grommet dots are 1/8 in.' : ''));
        files.notes.forEach(function (n) { pnote.push(n); });
        if (pnote.length) fd.append('properties[_Print file note]', pnote.join(' '));
        var skipArt = files.skipArt || {}; if (ART.front && !skipArt.front) fd.append('properties[Ardor Banner Artwork - ' + labelStamp + ']', ART.front.file, 'Ardor Banner Artwork ' + fileStamp + ext(ART.front.name));
        if (c.sides === 2 && S.backMode === 'different' && ART.back && !skipArt.back) fd.append('properties[Ardor Banner Back Artwork - ' + labelStamp + ']', ART.back.file, 'Ardor Banner Back Artwork ' + fileStamp + ext(ART.back.name));
        if (files.needEmail) fd.append('properties[Artwork file]', 'Too large to upload with the order. Please email it to info@ardorprinting.com.');
          fd.append('properties[_spec]', JSON.stringify({ w: c.W, h: c.H, m: c.mat.id, s: c.sides, g: c.grommet, p: c.pole, ps: c.poleSize, wb: c.webbing, r: c.rope, sl: c.slits, co: c.corners, hw: c.hw, pf: c.prof, d: S.design, q: c.qty, u: p.unit }));
        return new Promise(function (resolve, reject) {
          var xhr = new XMLHttpRequest();
          xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 200000) { var pct = Math.round(100 * e.loaded / e.total); btns.forEach(function (b) { b.textContent = pct < 100 ? 'Uploading\u2026 ' + pct + '%' : 'Adding\u2026'; }); } };
          xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) return resolve();
            var msg = xhr.status === 413 ? 'Your files are too big to upload with the order. Please try a smaller file, or request a quote.' : 'We couldn\'t add this to your cart. Please try again, or request a quote.';
            try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; if (xhr.status === 404 || xhr.status === 422) msg = 'Online ordering for custom banners isn\'t open yet. Please request a quote and we\'ll get right back to you.'; } catch (e) {}
            reject(new Error(msg));
          };
          xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
          xhr.send(fd);
        });
      });
    }).then(function () {
      track('ardor_banner_added_to_cart', { value: p.charged, material: c.mat.id, sq_ft: c.W * c.H, quantity: c.qty });
      toast(S.design ? 'Added to your cart. We\'ll email your design proof to approve.' : (emailProof ? 'Added to your cart. We\'ll email you a proof to approve before we print.' : 'Added to your cart. Your signed proof is saved with your order.'));
      window.location.href = CONF.cartUrl || '/cart';
    }).catch(function (err) { if (err && err.cancel) { done(); return; } showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done(); });
  }

  // ---------- quote (HubSpot form) ----------
  function summaryText() {
    var c = cfg(); var p = price(c);
    var lines = specLines(c, p).map(function (l) { return l[0] + ': ' + l[1]; });
    lines.push('Hem: ' + hemLabel(c).replace(/\.$/, ''));
    if (ART.front) lines.push('Artwork: ' + ART.front.name + ' (I will send the file)');
    var pl = placementText(ART.front, c); if (pl) lines.push('Placement: ' + pl);
    if (c.sides === 2) lines.push('Back: ' + (S.backMode === 'different' ? (ART.back ? ART.back.name : 'different art') : 'same as front'));
    var brief = ($('[data-abb-design-brief]').value || '').trim(); if (S.design && brief) lines.push('Design brief: ' + brief);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
    if (S.delivery) lines.push('Delivery: ' + (S.delivery === 'pickup' ? 'Pick up in Snohomish' : 'Ship'));
    if (!problems(c)) lines.push('Online price shown: ' + money(p.charged) + (c.qty > 1 ? ' (' + money(p.unit) + ' each)' : ''));
    return lines.join('\n');
  }

  function openQuote() {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText();
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = 'Banner from the Ardor Banner Builder\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      document.body.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function bind() {
    root.__abbArtSize = function () { var a = artFor(S.face); return a && a.img ? { w: a.natW, h: a.natH, kind: a.kind } : null; }; // v2: lets the Match art size button read the art's shape
    var wI = $('[data-abb-w]'), hI = $('[data-abb-h]'), qI = $('[data-abb-qty]');
    wI.addEventListener('input', function () { S.w = wI.value; render(); });
    hI.addEventListener('input', function () { S.h = hI.value; render(); });
    [wI, hI].forEach(function (el) { el.addEventListener('blur', function () { render(); }); });
    $('[data-abb-swap]').addEventListener('click', function () { set({ w: S.h, h: S.w }); });
    qI.addEventListener('input', function () { var n = parseInt(qI.value, 10); if (isFinite(n) && n >= 1) { S.qty = Math.min(500, n); render(); } });
    qI.addEventListener('blur', function () { qI.value = String(cfg().qty); });
    $('[data-abb-qty-minus]').addEventListener('click', function () { set({ qty: Math.max(1, cfg().qty - 1) }); });
    $('[data-abb-qty-plus]').addEventListener('click', function () { set({ qty: Math.min(500, cfg().qty + 1) }); });
    $$('[data-abb-delivery]').forEach(function (r) { r.addEventListener('change', function () { S.delivery = r.value; $('.abb-delivery').classList.remove('is-missing'); showErr(''); }); });
    $('[data-abb-design]').addEventListener('change', function (e) { set({ design: e.target.checked }); });
    var fileIn = $('[data-abb-file]');
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; loadFile(f, S.face === 'back' ? 'back' : 'front', true); fileIn.value = ''; });
    var drop = $('[data-abb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; loadFile(f, S.face === 'back' ? 'back' : 'front', true); });
    $$('[data-abb-face]').forEach(function (b) { b.addEventListener('click', function () { S.face = b.getAttribute('data-abb-face'); render(); }); });
    $('[data-abb-back-same]').addEventListener('change', function () { S.backMode = 'same'; S.artVer++; render(); });
    $('[data-abb-back-diff]').addEventListener('change', function () { S.backMode = 'different'; S.artVer++; render(); });
    $('[data-abb-flip]').addEventListener('click', function () { S.back = !S.back; view.flipTarget = S.back ? Math.PI : 0; view.lastInput = performance.now(); render(); });
    $('[data-abb-wind]').addEventListener('click', function () { set({ wind: !S.wind }); });
    $('[data-abb-lights]').addEventListener('click', function () { set({ lights: !S.lights }); });
    $('[data-abb-zoom-in]').addEventListener('click', function () { view.zoom = Math.min(4, view.zoom * 1.25); view.lastInput = performance.now(); });
    $('[data-abb-zoom-out]').addEventListener('click', function () { view.zoom = Math.max(0.6, view.zoom / 1.25); view.lastInput = performance.now(); });
    $('[data-abb-reset]').addEventListener('click', function () { view.yaw = 0; view.pitch = 0.06; view.zoom = 1; view.flipTarget = 0; view.lastInput = -100; set({ back: false }); });
    $('[data-abb-add]').addEventListener('click', addToCart);
    $('[data-abb-add-m]').addEventListener('click', addToCart);
    $('[data-abb-add-d]').addEventListener('click', addToCart);
    $('[data-abb-quote]').addEventListener('click', openQuote);
    $('[data-abb-quote-close]').addEventListener('click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    $('[data-abb-quote-copy]').addEventListener('click', copyQuote);
    $('[data-abb-quote-go]').addEventListener('click', function () { track('ardor_banner_quote_request', { value: price(cfg()).charged }); });
    bindLayout();
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    $('[data-abb-sig-text]').addEventListener('input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    $('[data-abb-approve-form]').addEventListener('submit', submitApproval);
    $('[data-abb-approve-form]').addEventListener('input', function () { $('[data-abb-approve-error]').hidden = true; });
    $('[data-abb-sig]').addEventListener('pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    $('[data-abb-approve-close]').addEventListener('click', function () { closeApproval(null); });
    $('[data-abb-approve-back]').addEventListener('click', function () { closeApproval(null); });
    $('[data-abb-approve]').addEventListener('cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }

  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  function init() {
    watchHeader();
    bind();
    render();
    startEngine();
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
    idle(function () { loadPrices().catch(function () {}); });
    window.ArdorBannerBuilder = { state: S, cfg: cfg, price: price, render: render, bands: bands, holes: holes, slits: slitsFor }; // v3-v2: geometry for the template PDF
    // v3: used by ardor-banner-layers.js (text, clipart, logo layers and the AI banner hand-off)
    window.ArdorBannerAPI = {
      cfg: cfg, conf: CONF, state: S, root: root, loadFile: loadFile, set: set, render: render, paintFace: paintFace, toast: toast,
      getArt: function (face) { return ART[face === 'back' ? 'back' : 'front']; },
      setArt: function (face, a) { ART[face === 'back' ? 'back' : 'front'] = a || null; S.artVer++; render(); },
      renderArtOnly: function () { S.artVer++; renderArtOnly(); },
      layoutCanvas: function () { return lay.canvas; },
      layoutScale: function () { return lay.scale; },
      editFace: function () { return S.face === 'back' ? (S.backMode === 'different' ? 'back' : null) : 'front'; },
      artGeom: function (f, Wi, Hi) { var a = typeof f === 'string' ? artFor(f) : f, c = cfg(); return a && a.natW > 0 ? geomForArt(a, a.natW, a.natH, Wi || c.W * 12, Hi || c.H * 12) : null; }
    };
    window.ArdorBannerBuilder.proof = { noun: 'banner', file: 'Ardor Banner Proof Preview', stamp: stampFile, make: function () { // the PDF button (assets/ardor-proofsheet.js)
var c = cfg(), waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
return Promise.all(waits).then(function () { return buildFiles(c, null, 'preview'); }).then(function (f) { return f && f.proof; });
} };
try { document.dispatchEvent(new CustomEvent('ardor:banner-api')); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
